import axiosClient from "./axiosClient";

// API quản lý Utility Blocks (khối tiện ích động trên trang chủ app).
const utilityBlockApi = {
    getAll() {
        return axiosClient.get("utility-block");
    },
    create(formData) {
        return axiosClient.post("utility-block", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    update(id, formData) {
        return axiosClient.put(`utility-block/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    toggle(id) {
        return axiosClient.patch(`utility-block/${id}/toggle`);
    },
    delete(id) {
        return axiosClient.delete(`utility-block/${id}`);
    },
    bulkDelete(ids) {
        return axiosClient.post("utility-block/bulk-delete", { ids });
    },
    reorder(orders) {
        return axiosClient.post("utility-block/reorder", { orders });
    },
};

export default utilityBlockApi;
